import { render } from "./TuitionDiscountsContent.vue?vue&type=template&id=97e4c658&ts=true"
import script from "./TuitionDiscountsContent.vue?vue&type=script&lang=ts"
export * from "./TuitionDiscountsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__